import { InactivationReasonCode } from './inactivationReasons';

export const INACTIVATION_REASON_TRANSLATION_KEYS: Record<
  InactivationReasonCode,
  string
> = {
  UNJUSTIFIED_ABSENCE: 'inactivation.reasons.UNJUSTIFIED_ABSENCE',
  JUSTIFIED_ABSENCE: 'inactivation.reasons.JUSTIFIED_ABSENCE',
  MEDICAL_CERTIFICATE: 'inactivation.reasons.MEDICAL_CERTIFICATE',
  TEMPORARY_ABSENCE: 'inactivation.reasons.TEMPORARY_ABSENCE',
  MEDICAL_LEAVE: 'inactivation.reasons.MEDICAL_LEAVE',
  SOCIAL_SECURITY_LEAVE: 'inactivation.reasons.SOCIAL_SECURITY_LEAVE',
  MATERNITY_LEAVE: 'inactivation.reasons.MATERNITY_LEAVE',
  PATERNITY_LEAVE: 'inactivation.reasons.PATERNITY_LEAVE',
  PARENTAL_LEAVE: 'inactivation.reasons.PARENTAL_LEAVE',
  UNPAID_LEAVE: 'inactivation.reasons.UNPAID_LEAVE',
  VACATION: 'inactivation.reasons.VACATION',
  COLLECTIVE_VACATION: 'inactivation.reasons.COLLECTIVE_VACATION',
  COMPANY_RECESS: 'inactivation.reasons.COMPANY_RECESS',
  VOLUNTARY_TERMINATION: 'inactivation.reasons.VOLUNTARY_TERMINATION',
  RESIGNATION: 'inactivation.reasons.RESIGNATION',
  INVOLUNTARY_TERMINATION: 'inactivation.reasons.INVOLUNTARY_TERMINATION',
  TERMINATION_WITHOUT_CAUSE: 'inactivation.reasons.TERMINATION_WITHOUT_CAUSE',
  TERMINATION_WITH_CAUSE: 'inactivation.reasons.TERMINATION_WITH_CAUSE',
  MUTUAL_AGREEMENT_TERMINATION: 'inactivation.reasons.MUTUAL_AGREEMENT_TERMINATION',
  END_OF_CONTRACT: 'inactivation.reasons.END_OF_CONTRACT',
  END_OF_PROBATION_PERIOD: 'inactivation.reasons.END_OF_PROBATION_PERIOD',
  RETIREMENT: 'inactivation.reasons.RETIREMENT',
  DEATH: 'inactivation.reasons.DEATH',
  LAYOFF: 'inactivation.reasons.LAYOFF',
  DUPLICATE_RECORD: 'inactivation.reasons.DUPLICATE_RECORD',
  NO_WORK_DEVICE: 'inactivation.reasons.NO_WORK_DEVICE',
  NO_CORPORATE_EMAIL_OR_PHONE: 'inactivation.reasons.NO_CORPORATE_EMAIL_OR_PHONE',
  ACCESS_TEMPORARILY_BLOCKED: 'inactivation.reasons.ACCESS_TEMPORARILY_BLOCKED',
  CUSTOM: 'inactivation.reasons.CUSTOM',
};
